import { render, staticRenderFns } from "./UserSection.vue?vue&type=template&id=7bad4c42&"
import script from "./UserSection.vue?vue&type=script&lang=js&"
export * from "./UserSection.vue?vue&type=script&lang=js&"
import style0 from "./UserSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports